import { render, staticRenderFns } from "./AvatarSection.htm?vue&type=template&id=c0a3337c&scoped=true&"
import script from "./AvatarSection.ts?vue&type=script&lang=js&"
export * from "./AvatarSection.ts?vue&type=script&lang=js&"
import style0 from "./AvatarSection.scss?vue&type=style&index=0&id=c0a3337c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0a3337c",
  null
  
)

export default component.exports